module.exports = __webpack_public_path__ + "img/loop@2x.f0ef2565.png";